import Axios from 'configs/Axios';
import { GetEmailTemplate, PostEmailTemplates } from 'types/emailTemplates';

export const getTemplate = (emailType: GetEmailTemplate) =>
  Axios.get<string>(`/template/${emailType}`);

export const updateTemplate = ({ emailType, data }: PostEmailTemplates) =>
  Axios.post(`/template/${emailType}`, data);
